import React from 'react';
import { Button } from './ui/Button';
interface HeroSectionProps {
  onBookConsultation?: () => void;
}
export function HeroSection({
  onBookConsultation
}: HeroSectionProps) {
  return <section className="relative min-h-screen flex items-center justify-center pt-[60px] overflow-hidden" data-id="element-109">
      {/* Parallax Background using CSS fixed attachment and a moody gradient to simulate the editorial photography */}
      <div className="absolute inset-0 z-0 bg-fixed bg-center bg-cover" style={{
      backgroundImage: 'linear-gradient(to bottom right, rgba(26, 17, 8, 0.85), rgba(26, 17, 8, 0.4)), radial-gradient(circle at center, #3D2E1C 0%, #1A1108 100%)'
    }} aria-hidden="true" data-id="element-110" />

      <div className="relative z-10 max-w-5xl mx-auto px-4 md:px-8 text-center flex flex-col items-center" data-id="element-111">
        <span className="font-sans text-sm md:text-base text-sage uppercase tracking-[0.2em] mb-6 font-medium" data-id="element-112">
          Advanced Hair Restoration · Be Clinical San Ramon
        </span>

        <h1 className="font-serif text-[28px] leading-[1.1] md:text-6xl lg:text-7xl text-cream font-light mb-8 max-w-4xl" data-id="element-113">
          Your Hair Was Never Gone.
          <br className="hidden md:block" data-id="element-114" /> It Just Needed Waking Up.
        </h1>

        <p className="font-sans text-base md:text-xl text-cream/80 max-w-2xl mb-10 leading-relaxed" data-id="element-115">
          Our advanced hair restoration uses the healing power already in your
          blood to reactivate dormant follicles and restore what's naturally
          yours — no implants, no chemicals, no guesswork.
        </p>

        <Button variant="primary" className="w-full md:w-auto shadow-xl shadow-black/20" onClick={onBookConsultation} data-id="element-116">
          Book Your Free Consultation
        </Button>

        <div className="mt-8 flex items-center gap-2 text-cream/70 font-sans text-sm" data-id="element-117">
          <div className="flex items-center gap-0.5" data-id="element-118">
            {[...Array(5)].map((_, i) => <svg key={i} className="w-4 h-4 text-gold fill-current" viewBox="0 0 20 20" data-id="element-119">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-120" />
              </svg>)}
          </div>
          <span data-id="element-121">250+ Reviews · 4.9 Stars · San Ramon, CA</span>
        </div>
      </div>
    </section>;
}